import { useRef } from 'react';
import { useToggle } from 'react-use';
import { getIconPopoverStyles, getIconStyles, getContentStyles } from './IconPopoverStyles.js';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { Popover } from '../Popover/Popover.js';
import { IconSize } from '../Icon/types/size.js';
import { Icon } from '../Icon/Icon.js';

function IconPopover(_ref) {
  let {
    icon,
    size = IconSize.SIZE_REGULAR,
    placement,
    isScrollable,
    offset,
    children,
    container,
    ...rest
  } = _ref;
  const buttonRef = useRef(null);
  const [isOpen, toggleIsOpen] = useToggle(false);
  const togglePopover = e => {
    e.stopPropagation();
    toggleIsOpen();
  };
  const handleOnClickAway = e => {
    var _buttonRef$current;
    if ((_buttonRef$current = buttonRef.current) !== null && _buttonRef$current !== void 0 && _buttonRef$current.contains(e.composedPath()[0])) {
      return;
    }
    toggleIsOpen();
  };
  return jsxs(Fragment, {
    children: [jsx("button", {
      ref: buttonRef,
      css: getIconPopoverStyles,
      type: "button",
      onClick: togglePopover,
      ...rest,
      children: jsx(Icon, {
        name: icon,
        size: size,
        css: getIconStyles
      })
    }), jsx(Popover, {
      reference: buttonRef.current,
      isOpen: isOpen,
      onClickAway: handleOnClickAway,
      placement: placement,
      isScrollable: isScrollable,
      offset: offset,
      container: container,
      children: jsx("div", {
        css: getContentStyles,
        children: children
      })
    })]
  });
}

export { IconPopover };
//# sourceMappingURL=IconPopover.js.map
